<div>
  <div class="d-md-block d-block">
    <ngb-progressbar [height]="progressBarHeight" [value]="percentComplete"></ngb-progressbar>
  </div>
</div>
